import Button from '../../../components/base/Button';
import Product1 from '../../../assests/images/product1.png';
import Product2 from '../../../assests/images/product2.png';
import Image1 from '../../../assests/images/front.png';
import Image2 from '../../../assests/images/exterior.png';
export default function CafeHighlight() {
  return (
    <section id="cafe" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-4xl md:text-5xl font-bold text-stone-900 mb-6">
              The Delhi Café Experience
            </h2>
            <p className="text-xl text-gray-600 mb-8 leading-relaxed">
              Step into our cozy café in the heart of Delhi, where every cup tells a story. 
              From expertly crafted lattes to traditional matcha ceremonies, we create moments 
              that bring people together over exceptional beverages.
            </p>
            
            <div className="space-y-4 mb-8">
              <div className="flex items-center space-x-3">
                <div className="w-6 h-6 bg-green-600 rounded-full flex items-center justify-center">
                  <i className="ri-check-line text-white text-sm"></i>
                </div>
                <span className="text-gray-700">Artisan coffee & matcha preparation</span>
              </div>
              <div className="flex items-center space-x-3">
                <div className="w-6 h-6 bg-green-600 rounded-full flex items-center justify-center">
                  <i className="ri-check-line text-white text-sm"></i>
                </div>
                <span className="text-gray-700">Cozy atmosphere perfect for work or relaxation</span>
              </div>
              <div className="flex items-center space-x-3">
                <div className="w-6 h-6 bg-green-600 rounded-full flex items-center justify-center">
                  <i className="ri-check-line text-white text-sm"></i>
                </div>
                <span className="text-gray-700">Local community hub for coffee lovers</span>
              </div>
            </div>
            
            <a target='__Blank__' href="https://www.google.co.in/maps/place/Roaffees+%7C+Coffee+%26+Matcha/@28.703657,77.2255059,17z/data=!3m1!4b1!4m6!3m5!1s0x390cfbcc8b637531:0x28bcbae7a0439d25!8m2!3d28.703657!4d77.2280808!16s%2Fg%2F11y94m9t8j?entry=ttu&g_ep=EgoyMDI1MTEyMy4xIKXMDSoASAFQAw%3D%3D">
            <Button size="lg">
              <i className="ri-map-pin-line mr-2"></i>
              Find Our Café
            </Button>
            </a>
          </div>
          
          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-4">
              <img 
                src={Product1}
                alt="Café Interior"
                className="w-full h-64 object-cover object-center rounded-2xl shadow-lg"
              />
              <img 
                src={Product2}
                alt="Latte Art"
                className="w-full h-48 object-cover object-center rounded-2xl shadow-lg"
              />
            </div>
            <div className="space-y-4 mt-8">
              <img 
                src={Image1}
                alt="Matcha Ceremony"
                className="w-full h-48 object-cover object-center rounded-2xl shadow-lg"
              />
              <img 
                src={Image2}
                alt="Café Customers"
                className="w-full h-64 object-cover object-center rounded-2xl shadow-lg"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
